import { CAMPAIGN_TYPE, alwaysPaidSource, alwaysPaidMedium, campaignMapping } from "../Constants/campaign";
import SessioStorageHelper from "../Utils/SessionStorageHelper";
import { UTM_PARAMS_KEY } from "../Constants/campaign";
export var getCampaignType = function getCampaignType(query, config) {
  var _a;
  var utm_source = query.utm_source,
    utm_medium = query.utm_medium;
  if (alwaysPaidSource.includes(utm_source)) {
    return CAMPAIGN_TYPE.PAID;
  }
  if (alwaysPaidMedium.includes(utm_medium)) {
    return CAMPAIGN_TYPE.PAID;
  }
  if (campaignMapping[utm_source] && campaignMapping[utm_source].includes(utm_medium)) {
    return CAMPAIGN_TYPE.PAID;
  }
  var _ref = config || {},
    paidCampaign = _ref.paidCampaign;
  if (paidCampaign) {
    var _alwaysPaidSource = paidCampaign.alwaysPaidSource,
      _alwaysPaidMedium = paidCampaign.alwaysPaidMedium,
      _paidCampaign$sourceM = paidCampaign.sourceMediumMap,
      sourceMediumMap = _paidCampaign$sourceM === void 0 ? {} : _paidCampaign$sourceM;
    if (_alwaysPaidSource === null || _alwaysPaidSource === void 0 ? void 0 : _alwaysPaidSource.includes(utm_source)) {
      return CAMPAIGN_TYPE.PAID;
    }
    if (_alwaysPaidMedium === null || _alwaysPaidMedium === void 0 ? void 0 : _alwaysPaidMedium.includes(utm_medium)) {
      return CAMPAIGN_TYPE.PAID;
    }
    if ((_a = sourceMediumMap[utm_source]) === null || _a === void 0 ? void 0 : _a.includes(utm_medium)) {
      return CAMPAIGN_TYPE.PAID;
    }
  }
  return CAMPAIGN_TYPE.ORGANIC;
};
export var getCampaignInfo = function getCampaignInfo(_ref2, config) {
  var query = _ref2.query;
  var channelOfAcquisition = {};
  if (query && (query.utm_campaign || query.utm_source)) {
    var channel = Array.isArray(query.utm_source) ? query.utm_source[0] : query.utm_source;
    channelOfAcquisition = {
      channel: channel || null,
      type: getCampaignType(query, config),
      adName: query.utm_term || null,
      campaignName: query.utm_campaign || null,
      mediumName: query.utm_medium || null,
      keywordName: query.utm_keyword || null,
      termName: query.utm_term || null,
      allTabs: query.utm_all_tabs || null,
      content: query.utm_content || null
    };
  }
  return channelOfAcquisition;
};
export function setSessionUtmParams(location, config) {
  var utmParams = getCampaignInfo(location, config);
  if (!utmParams || !Object.keys(utmParams).length) {
    return;
  }
  SessioStorageHelper.setItem(UTM_PARAMS_KEY, JSON.stringify(utmParams));
}
export function getSessionShowAllTabs(location) {
  var _ref3 = location || {},
    _ref3$query = _ref3.query,
    _ref3$query2 = _ref3$query === void 0 ? {} : _ref3$query,
    _ref3$query2$utm_all_ = _ref3$query2.utm_all_tabs,
    utmAllTabs = _ref3$query2$utm_all_ === void 0 ? null : _ref3$query2$utm_all_;
  var utmParams_string = SessioStorageHelper.getItem(UTM_PARAMS_KEY);
  var _ref4 = utmParams_string ? JSON.parse(utmParams_string) : {},
    _ref4$allTabs = _ref4.allTabs,
    allTabs = _ref4$allTabs === void 0 ? utmAllTabs : _ref4$allTabs;
  return !!allTabs && allTabs !== 'false';
}
export var getChannelOfAcquisition = function getChannelOfAcquisition(query, config) {
  var campaign = getCampaignInfo({
    query: query
  }, config);
  if (!campaign || !Object.keys(campaign).length) {
    var utmParams_string = SessioStorageHelper.getItem(UTM_PARAMS_KEY);
    var defaultChannelOfAcquisition = {
      channel: 'default',
      type: CAMPAIGN_TYPE.ORGANIC,
      adName: null
    };
    campaign = utmParams_string ? JSON.parse(utmParams_string) : defaultChannelOfAcquisition;
  }
  var _ref5 = campaign || {},
    channel = _ref5.channel,
    type = _ref5.type,
    adName = _ref5.adName;
  return {
    channel: channel,
    type: type,
    adName: adName
  };
};
export var isPaidCampaign = function isPaidCampaign(query, config) {
  var campaign = getChannelOfAcquisition(query, config);
  return campaign.type === CAMPAIGN_TYPE.PAID;
};
export default {
  isPaidCampaign: isPaidCampaign,
  getCampaignInfo: getCampaignInfo,
  setSessionUtmParams: setSessionUtmParams,
  getChannelOfAcquisition: getChannelOfAcquisition,
  getSessionShowAllTabs: getSessionShowAllTabs
};